import { HallPermissions } from '@weblite/ts-action/hall'
import {
  Admin,
  ChannelAdminChangeablePermissions,
} from '@weblite/ts-action/subscription'
import { IAction } from '@weblite/ts-action/types'
import { coreActionMaker } from '@weblite/ts-action/utils'

declare module '@weblite/ts-action/hall' {
  interface HallPermissions {
    questionSupport: boolean
  }
}

export const REQ_GET_CHANNEL_MANAGERS = 'REQ_GET_CHANNEL_MANAGERS'
export const REQ_SET_QUESTION_SUPPORT = 'REQ_SET_QUESTION_SUPPORT'

export type ChannelManagerPermissions = ChannelAdminChangeablePermissions &
  Pick<HallPermissions, 'questionSupport'>

export type ChannelManager = Admin & {
  role: 'ADMIN' | 'QUESTION_SUPPORT'
  decodedPermissions: ReturnType<
    typeof import('@weblite/permission').decodeSubscriptionPermission
  > & { questionSupport: boolean }
}

interface GetChannelManagers extends IAction {
  Req: { roomId: string }
  Res: { managers: Omit<ChannelManager, 'decodedPermissions'>[] }
}

interface SetQuestionSupport extends IAction {
  Req: { roomId: string; userId: string; enabled: boolean }
  Res: null
}

export const reqGetChannelManagers = coreActionMaker<GetChannelManagers['Req']>(
  REQ_GET_CHANNEL_MANAGERS,
)
export const reqSetQuestionSupport = coreActionMaker<SetQuestionSupport['Req']>(
  REQ_SET_QUESTION_SUPPORT,
)

export type { GetChannelManagers, SetQuestionSupport }
